<template>
  <div class="mind-map-box">
    <div id="mindMapContainer"></div>
    <Toolbor
    :treeObj="treeObj"
    :readonly="readonly"
    :mindMap="mindMap"
    :currentNode="currentNode"
    :isStart="isStart"
    :isEnd="isEnd"/>
    <SearchBar v-if="mindMap" :mindMap="mindMap"/>
    <ContextMenu v-if="mindMap" :mindMap="mindMap"/>
    <ShortcutKey v-if="mindMap" :mindMap="mindMap"/>
    <Structure v-if="mindMap" :mindMap="mindMap"/>
    <Setting v-if="mindMap" :mindMap="mindMap" />
    <Style v-if="mindMap" :mindMap="mindMap"/>
    <el-dialog title="新增脑图" :visible.sync="addMindVisible" width="40%">
      <el-input v-model="mindTitle" placeholder="请输入脑图名称" clearable />
      <span slot="footer" class="dialog-footer">
        <el-button @click="addMindVisible = false">取 消</el-button>
        <el-button type="primary" @click="addMindMap">确 定</el-button>
      </span>
    </el-dialog>
    <ExportComponent></ExportComponent>
    <ImportComponent></ImportComponent>
    <List></List>
    <FormulaSidebar v-if="mindMap" :mindMap="mindMap"></FormulaSidebar>
  </div>
</template>

<script>
import axios from "@/http";
import MindMap from "simple-mind-map";
import Export from 'simple-mind-map/src/plugins/Export.js';
import Search from 'simple-mind-map/src/plugins/Search.js';
import Select from 'simple-mind-map/src/plugins/Select.js';
import Watermark from 'simple-mind-map/src/plugins/Watermark.js';
import NodeImgAdjust from 'simple-mind-map/src/plugins/NodeImgAdjust.js'
import RichText from 'simple-mind-map/src/plugins/RichText.js'
import Formula from 'simple-mind-map/src/plugins/Formula.js'
import Vue from 'vue';
import ContextMenu from "./components/ContextMenu.vue";
import ExportComponent from "./components/Export.vue";
import ImportComponent from './components/Import.vue';
import List from './components/List.vue';
import SearchBar from "./components/SearchBar.vue";
import Setting from './components/Setting.vue';
import ShortcutKey from "./components/ShortcutKey.vue";
import Structure from "./components/Structure.vue";
import FormulaSidebar from "./components/FormulaSidebar.vue";
import Style from "./components/Style.vue";
import Toolbor from "./components/Toolbor.vue";
import Excel from './excel.esm.min.js';
import { hideLoading, showLoading } from './utils/loading';

MindMap.usePlugin(RichText, {
  fontFamilyList: '微软雅黑, Microsoft YaHei'
})
MindMap.usePlugin(Formula)
MindMap.usePlugin(Search)
MindMap.usePlugin(Select)
MindMap.usePlugin(Export)
MindMap.usePlugin(Watermark)
MindMap.usePlugin(NodeImgAdjust)
const events = ['node_contextmenu', 'data_change', 'node_click', 'draw_click', 'node_active', 'showNodeLink', 'mouseup', 'svg_mousedown', 'generalization_node_contextmenu']
export default {
  props: {
    treeObj: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    width: {
      type: String
    },
    height: {
      type: String
    }
  },
  components: {
    Toolbor,
    SearchBar,
    ContextMenu,
    ShortcutKey,
    ExportComponent,
    ImportComponent,
    Structure,
    Setting,
    Style,
    FormulaSidebar,
    List
  },
  data() {
    return {
      num: 1,
      mindMap: null,
      isStart: false,
      isEnd: false,
      currentNode: null,
      currendMindId: null,
      isFirst: true,
      addMindVisible: false,
      mindTitle: ''
    }
  },
  methods: {
    // 递归处理节点
    processNode(item) {
      let node = {
        data: {
          text: item.content
        }
      };

      // 如果存在子节点，递归处理
      if (item.children && item.children.length > 0) {
        node.children = item.children.map(child => this.processNode(child));
      }

      return node;
    },
    openAddMindMap() {
      this.addMindVisible = true
    },
    openAddTimeline() {
      // 向父组件发送添加时间轴事件
      this.$emit('openAddTimeline')
    },

    addMindMap() {
      const userInfo = JSON.parse(localStorage.getItem('userinfo'))
      this.addMindVisible = false
      axios.post('/ai/mind/add', {
          title: this.mindTitle,
          memberId: userInfo.userid
      }).then(res => {
        if(res.code === 200) {
          this.$message.success('添加成功')
          window.open(`#/mind/${res.data}`, '_blank');
        } else {
          this.$message.error('添加失败')
        }
      })
    },

    getMindMapData() {
      console.log('🔄 从原始数据生成脑图数据')
      console.log('🔄 treeObj:', this.treeObj)
      console.log('🔄 treeObj结构:', JSON.stringify(this.treeObj, null, 2))
      
      if(!this?.treeObj?.children?.length) {
        const simpleObj = {
          "data": {
              "text": this.treeObj.content
          },
          "children": []
        }
        console.log('🔄 生成简单脑图数据 (无子节点):', simpleObj)
        return simpleObj
      }
      let obj = {
        data: {
          text: this.treeObj.content
        },
        children: this.treeObj.children.map(item => this.processNode(item))
      }
      console.log('🔄 生成完整脑图数据 (有子节点):', obj)
      console.log('🔄 生成的脑图数据结构:', JSON.stringify(obj, null, 2))
      return obj;
    },
    getMindMap() {
      return new Promise((resolve, reject) => {
        if(this.treeObj?.detail && this.treeObj.detail !== 'null' && this.treeObj.detail !== null) {
          console.log('📖 从detail字段加载脑图数据 (已保存的数据):', this.treeObj.detail)
          console.log('📖 detail字段类型:', typeof this.treeObj.detail)
          try {
            const parsedData = JSON.parse(this.treeObj.detail)
            console.log('📖 解析后的数据:', parsedData)
            console.log('📖 解析后的数据结构:', JSON.stringify(parsedData, null, 2))
            resolve(parsedData)
          } catch (error) {
            console.error('📖 解析detail字段失败:', error)
            console.log('📖 fallback到使用原始数据生成脑图')
            resolve(null)
          }
        } else {
          console.log('📖 没有detail字段或detail为空，将使用原始数据生成脑图')
          resolve(null)
        }
      })
    },
    execCommand(...args) {
      this.mindMap.execCommand(...args)
    },
    allEvent() {
      this.busEvent()
      this.$bus.$on('execCommand', this.execCommand)
    this.$bus.$on('insertMiddleNode', this.insertMiddleNode)
      this.$bus.$on('moveToSiblingAsChild', this.moveToSiblingAsChild)
      this.$bus.$on('setData', this.setData)
      events.forEach((evt) => {
        this.mindMap.on(evt, (...args) => {
          this.$bus.$emit(evt, ...args)
        })
      })
    },
    busEvent() {
      this.$bus.$on('openAddMindMap', this.openAddMindMap)
      this.$bus.$on('openAddTimeline', this.openAddTimeline)
      this.$bus.$on('export', (obj) => {
        this.mindMap.export(obj)
      })
      this.$bus.$on('data_change', data => {
          const params = {
            id: this.treeObj.mind_map_id,
            detail: JSON.stringify(data)
          }
          if(!this.isFirst) {
            axios.post('/ai/mind/save', params).then(res => {
              this.$message.success('保存成功')
            })
          }
          this.isFirst = false
      })
    },
    // 将节点移动到同级节点下
    moveToSiblingAsChild(node) {
      if (!node || !node.parent) {
        this.$message.warning('无法移动根节点')
        return
      }
      
      if (node.isRoot) {
        this.$message.warning('无法移动根节点')
        return
      }
      
      try {
        // 获取完整数据
        const fullData = this.mindMap.getData()
        
        // 获取当前节点的文本和uid
        const currentNodeText = node.getData('text')
        const currentNodeUid = node.uid
        
        // 获取父节点的文本
        const parentNodeText = node.parent.getData('text')
        
        // 获取所有同级节点
        const siblings = node.parent.children || []
        const currentIndex = siblings.findIndex(item => item.uid === currentNodeUid)
        
        if (currentIndex <= 0) {
          this.$message.warning('该节点已经是第一个同级节点，无法移动到前一个节点下')
          return
        }
        
        // 找到前一个同级节点
        const previousSibling = siblings[currentIndex - 1]
        const previousSiblingText = previousSibling.getData('text')
        
        // 在数据中找到并移动节点
        const success = this.moveNodeToSiblingInData(fullData, currentNodeText, currentNodeUid, previousSiblingText, previousSibling.uid)
        
        if (success) {
          // 保存当前视图状态
          const currentScale = this.mindMap.view.scale || 1
          const currentTransform = {
            x: this.mindMap.view.translateX || 0,
            y: this.mindMap.view.translateY || 0
          }
          
          // 重新设置数据
          this.mindMap.setData(fullData)
          
          // 等待渲染完成
          this.$nextTick(() => {
            // 恢复视图状态
            setTimeout(() => {
              try {
                this.mindMap.view.setScale(currentScale)
                this.mindMap.view.translateX = currentTransform.x
                this.mindMap.view.translateY = currentTransform.y
                this.mindMap.render()
              } catch (viewError) {
                console.log('恢复视图状态失败:', viewError)
              }
            }, 100)
          })
          
          this.$message.success('节点移动成功')
        } else {
          this.$message.error('未找到目标节点')
        }
        
      } catch (error) {
        console.error('移动节点失败:', error)
        this.$message.error('移动节点失败')
      }
    },
    
    // 在数据中移动节点到同级节点下
    moveNodeToSiblingInData(data, currentNodeText, currentNodeUid, targetSiblingText, targetSiblingUid) {
      // 如果找到父节点（包含目标同级节点和当前节点的节点）
      if (data.children && data.children.length > 0) {
        // 查找目标同级节点和当前节点
        let targetSiblingNode = null
        let currentNode = null
        let currentNodeIndex = -1
        
        for (let i = 0; i < data.children.length; i++) {
          const child = data.children[i]
          // 处理两种数据结构：{ text: ... } 或 { data: { text: ... } }
          const childText = child.text || child.data?.text || ''
          const childUid = child.uid || child.data?.uid || ''
          
          // 优先通过uid匹配，如果uid不存在则通过text匹配
          const isTargetSibling = (targetSiblingUid && childUid && childUid === targetSiblingUid) ||
                                   (!targetSiblingUid && childText === targetSiblingText)
          
          const isCurrentNode = (currentNodeUid && childUid && childUid === currentNodeUid) ||
                                (!currentNodeUid && childText === currentNodeText)
          
          if (isTargetSibling) {
            targetSiblingNode = child
          }
          
          if (isCurrentNode) {
            currentNode = child
            currentNodeIndex = i
          }
        }
        
        // 如果找到了目标节点和当前节点，且当前节点不是第一个
        if (targetSiblingNode && currentNode && currentNodeIndex > 0) {
          // 深拷贝当前节点（包括所有子节点）
          const removedNode = JSON.parse(JSON.stringify(currentNode))
          
          // 从原位置移除当前节点
          data.children.splice(currentNodeIndex, 1)
          
          // 确保目标节点有children数组
          if (!targetSiblingNode.children) {
            targetSiblingNode.children = []
          }
          
          // 将当前节点添加到目标节点的children中
          targetSiblingNode.children.push(removedNode)
          
          return true
        }
      }
      
      // 递归查找子节点
      if (data.children && data.children.length > 0) {
        for (let child of data.children) {
          if (this.moveNodeToSiblingInData(child, currentNodeText, currentNodeUid, targetSiblingText, targetSiblingUid)) {
            return true
          }
        }
      }
      
      return false
    },
    
    // 插入中间节点方法
    insertMiddleNode(node) {
      if (!node || !node.children || node.children.length === 0) {
        this.$message.warning('该节点没有子节点，无法插入中间节点')
        return
      }
      
      try {
        // 获取完整数据
        const fullData = this.mindMap.getData()
        
        // 获取目标节点文本
        const targetText = node.getData('text')
        
        // 在数据中找到并修改目标节点
        const success = this.insertMiddleNodeInData(fullData, targetText)
        
        if (success) {
          
          // 保存当前视图状态
          const currentScale = this.mindMap.view.scale || 1
          const currentTransform = {
            x: this.mindMap.view.translateX || 0,
            y: this.mindMap.view.translateY || 0
          }
          
          // 重新设置数据
          this.mindMap.setData(fullData)
          
          // 等待渲染完成
          this.$nextTick(() => {
            // 恢复视图状态
            setTimeout(() => {
              try {
                this.mindMap.view.setScale(currentScale)
                this.mindMap.view.translateX = currentTransform.x
                this.mindMap.view.translateY = currentTransform.y
                this.mindMap.render()
              } catch (viewError) {
                console.log('恢复视图状态失败:', viewError)
              }
            }, 100)
          })
          
          this.$message.success('中间节点插入成功')
        } else {
          this.$message.error('未找到目标节点')
        }
        
      } catch (error) {
        console.error('插入中间节点失败:', error)
        this.$message.error('插入中间节点失败')
      }
    },
    
    // 在数据中插入中间节点
    insertMiddleNodeInData(data, targetText) {
      // 处理嵌套的data结构
      const currentText = data.text || data.data?.text || ''
      
      if (currentText === targetText) {
        if (data.children && data.children.length > 0) {
          // 保存原有子节点
          const originalChildren = JSON.parse(JSON.stringify(data.children))
          
          // 创建符合现有格式的中间节点数据结构
          const middleNodeData = {
            data: {
              text: '中间节点',
              uid: this.generateUID(),
              isActive: false,
              expand: true,
              richText: false
            },
            children: originalChildren
          }
          
          // 确保所有子节点也有完整的数据结构
          this.ensureNodeDataIntegrity(middleNodeData)
          
          // 替换子节点
          data.children = [middleNodeData]
          
          return true
        }
      }
      
      // 递归查找子节点
      if (data.children && data.children.length > 0) {
        for (let child of data.children) {
          if (this.insertMiddleNodeInData(child, targetText)) {
            return true
          }
        }
      }
      
      return false
    },
    
    // 生成唯一ID
    generateUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    
    // 确保节点数据完整性
    ensureNodeDataIntegrity(nodeData) {
      // 处理嵌套的data结构
      const dataObj = nodeData.data || nodeData
      
      // 确保当前节点有必要的属性
      if (!dataObj.uid) {
        dataObj.uid = this.generateUID()
      }
      if (dataObj.isActive === undefined) {
        dataObj.isActive = false
      }
      if (dataObj.expand === undefined) {
        dataObj.expand = true
      }
      if (dataObj.richText === undefined) {
        dataObj.richText = false
      }
      
      // 如果是嵌套结构，确保data属性存在
      if (nodeData.data) {
        nodeData.data = dataObj
      }
      
      // 递归处理子节点
      if (nodeData.children && nodeData.children.length > 0) {
        nodeData.children.forEach(child => {
          this.ensureNodeDataIntegrity(child)
        })
      }
    },
    
    // 递归保存子节点信息
    saveChildrenRecursive(children) {
      return children.map(child => {
        const childInfo = {
          text: child.getData('text'),
          data: JSON.parse(JSON.stringify(child.nodeData.data || {}))
        }
        if (child.children && child.children.length > 0) {
          childInfo.children = this.saveChildrenRecursive(child.children)
        }
        return childInfo
      })
    },
    
    // 递归重建节点
    recreateNodeRecursive(parentNode, nodeInfo) {
      console.log('recreateNodeRecursive 被调用，父节点:', parentNode.getData('text'), '要创建的节点:', nodeInfo.text)
      
      try {
        // 选中父节点
        this.mindMap.renderer.setNodeActive(parentNode, true)
        console.log('选中父节点成功')
        
        // 尝试不同的方法创建子节点
        let newNode = null
        
        // 方法1: 使用 INSERT_CHILD_NODE 命令
        try {
          this.mindMap.execCommand('INSERT_CHILD_NODE')
          console.log('执行INSERT_CHILD_NODE命令完成')
          
          if (parentNode.children && parentNode.children.length > 0) {
            newNode = parentNode.children[parentNode.children.length - 1]
            console.log('方法1成功：获取新创建的节点')
          }
        } catch (cmd1Error) {
          console.log('方法1失败:', cmd1Error)
        }
        
        // 方法2: 如果方法1失败，尝试直接调用renderer方法
        if (!newNode) {
          try {
            this.mindMap.renderer.insertChildNode()
            console.log('执行renderer.insertChildNode()完成')
            
            if (parentNode.children && parentNode.children.length > 0) {
              newNode = parentNode.children[parentNode.children.length - 1]
              console.log('方法2成功：获取新创建的节点')
            }
          } catch (cmd2Error) {
            console.log('方法2失败:', cmd2Error)
          }
        }
        
        // 方法3: 如果前面都失败，尝试使用Tab键模拟
        if (!newNode) {
          try {
            // 模拟按Tab键创建子节点
            this.mindMap.keyCommand.onKeydown({
              keyCode: 9, // Tab键
              preventDefault: () => {},
              stopPropagation: () => {}
            })
            console.log('执行Tab键模拟完成')
            
            if (parentNode.children && parentNode.children.length > 0) {
              newNode = parentNode.children[parentNode.children.length - 1]
              console.log('方法3成功：获取新创建的节点')
            }
          } catch (cmd3Error) {
            console.log('方法3失败:', cmd3Error)
          }
        }
        
        if (newNode) {
          console.log('成功创建节点，当前父节点子节点数量:', parentNode.children.length)
          
          // 设置节点文本
          if (nodeInfo.text) {
            newNode.setText(nodeInfo.text)
            console.log('设置节点文本成功:', nodeInfo.text)
          }
          
          // 设置其他数据
          if (nodeInfo.data) {
            Object.keys(nodeInfo.data).forEach(key => {
              if (key !== 'children' && key !== 'text') {
                try {
                  newNode.setData(key, nodeInfo.data[key])
                } catch (setDataError) {
                  console.log('设置数据失败:', key, setDataError)
                }
              }
            })
            console.log('设置其他数据完成')
          }
          
          // 递归创建子节点
          if (nodeInfo.children && nodeInfo.children.length > 0) {
            console.log('开始递归创建子节点，数量:', nodeInfo.children.length)
            nodeInfo.children.forEach((childInfo, index) => {
              console.log(`创建第${index + 1}个子节点:`, childInfo.text)
              this.recreateNodeRecursive(newNode, childInfo)
            })
            console.log('递归创建子节点完成')
          }
          
          return newNode
        } else {
          console.error('所有方法都失败，无法创建子节点')
          return null
        }
      } catch (error) {
        console.error('recreateNodeRecursive 失败:', error)
        return null
      }
    },
    
    // 在数据结构中修改节点
    modifyNodeInData(data, targetText) {
      // 检查当前节点
      const currentText = data.text || data.data?.text || ''
      
      if (currentText === targetText) {
        console.log('找到目标节点，开始修改')
        if (data.children && data.children.length > 0) {
          // 保存原有子节点
          const originalChildren = JSON.parse(JSON.stringify(data.children))
          console.log('保存的原有子节点:', originalChildren)
          
          // 创建中间节点
          data.children = [{
            text: '中间节点',
            children: originalChildren
          }]
          
          console.log('修改后的节点结构:', data)
          return true
        }
      }
      
      // 递归查找子节点
      if (data.children && data.children.length > 0) {
        for (let child of data.children) {
          if (this.modifyNodeInData(child, targetText)) {
            return true
          }
        }
      }
      
      return false
    },
    
    // 深拷贝节点数据
    deepCloneNodeData(node) {
      const data = {
        text: node.getData('text') || '节点'
      }
      
      // 复制其他属性
      const nodeData = node.nodeData?.data || {}
      Object.keys(nodeData).forEach(key => {
        if (key !== 'children' && key !== 'text') {
          data[key] = nodeData[key]
        }
      })
      
      // 递归复制子节点
      if (node.children && node.children.length > 0) {
        data.children = node.children.map(child => this.deepCloneNodeData(child))
      }
      
      return data
    },
    
    // 从数据创建节点
    createNodeFromData(parentNode, nodeData) {
      // 选中父节点
      this.mindMap.renderer.setNodeActive(parentNode, true)
      
      // 创建子节点
      this.mindMap.execCommand('INSERT_CHILD_NODE')
      
      // 获取刚创建的节点
      if (parentNode.children && parentNode.children.length > 0) {
        const newNode = parentNode.children[parentNode.children.length - 1]
        
        // 设置节点文本
        if (nodeData.text) {
          newNode.setText(nodeData.text)
        }
        
        // 设置其他属性
        Object.keys(nodeData).forEach(key => {
          if (key !== 'children' && key !== 'text') {
            newNode.setData(key, nodeData[key])
          }
        })
        
        // 递归创建子节点
        if (nodeData.children && nodeData.children.length > 0) {
          nodeData.children.forEach(childData => {
            this.createNodeFromData(newNode, childData)
          })
        }
      }
    },
    
    // 在数据结构中查找指定uid的节点
    findNodeInData(data, uid) {
      if (data.uid === uid) {
        return data
      }
      
      if (data.children && data.children.length > 0) {
        for (let child of data.children) {
          const found = this.findNodeInData(child, uid)
          if (found) {
            return found
          }
        }
      }
      
      return null
    },

    // 动态设置思维导图数据
    setData(data) {
      showLoading()
      if (data.root) {
        this.mindMap.setFullData(data)
      } else {
        this.mindMap.setData(data)
      }
      this.mindMap.view.reset()
      setTimeout(() => {
        hideLoading()
      }, 1000)
    },
    async init() {
      console.log('🚀 初始化脑图组件')
      let data = await this.getMindMap()
      if(!data) {
        console.log('🚀 未找到保存的数据，使用原始数据生成')
        data = this.getMindMapData()
      } else {
        console.log('🚀 找到保存的数据，直接使用')
      }
      
      console.log('🚀 最终传入MindMap的数据:', data)
      console.log('🚀 最终数据结构:', JSON.stringify(data, null, 2))
      
      this.mindMap = new MindMap({
        el: document.getElementById('mindMapContainer'),
        data,
        enableShortcutOnlyWhenMouseInSvg: false,
        enableFreeDrag: false,
        readonly: this.readonly,
        // 是否仅搜索当前渲染的节点，被收起的节点不会被搜索到
        isOnlySearchCurrentRenderNodes: false,
      });
      
      // 调试信息：检查Search插件是否正确加载
      console.log('MindMap初始化完成')
      console.log('MindMap实例:', this.mindMap)
      console.log('Search插件是否存在:', !!this.mindMap.search)
      if (this.mindMap.search) {
        console.log('Search插件方法:', Object.getOwnPropertyNames(this.mindMap.search))
      } else {
        console.error('Search插件未正确加载！')
      }
      
      this.allEvent()
      this.mindMap.on('back_forward', (index, len) => {
          this.isStart = index <= 0
          this.isEnd = index >= len - 1
      })
      this.mindMap.on('node_click', (e, node) => {
        this.currentNode = node
        this.$bus.$emit('node_click', e, node)
      })
      this.mindMap.on('draw_click', (e, node) => {
        this.currentNode = null
        this.$bus.$emit('draw_click', e, node)
      })
      this.mindMap.on('node_contextmenu', (e, node) => {
        this.currentNode = node
        this.$bus.$emit('node_contextmenu', e, node)
      })
      
      // 添加快捷键支持
      this.mindMap.keyCommand.addShortcut('Control+m', () => {
        if (this.currentNode && this.currentNode.children && this.currentNode.children.length > 0) {
          this.insertMiddleNode(this.currentNode)
        }
      })
      this.mindMap.view.setScale(0.8)
      this.mindMap.view.translateX(-500)
      this.mindMap.view.translateY(100)
    },
  },
  beforeDestroy() {
    this.$bus.$off('execCommand', this.execCommand)
    this.$bus.$off('insertMiddleNode', this.insertMiddleNode)
    this.$bus.$off('moveToSiblingAsChild', this.moveToSiblingAsChild)
  },
  async mounted() {
    showLoading()
    await this.init()
    if(!this.currendMindId) {
      this.currendMindId = this.treeObj.id
    }
    this.mindMap.addPlugin(Excel)
    Vue.prototype.Excel = Excel
    this.$nextTick(() => {
      hideLoading()
    })
  }
}

</script>
<style lang="scss" scoped>
#mindMapContainer{
  min-height: 200px;
  min-width: 200px;
  width: 100%;
  height: 100%;
}
#treePlan{
  background-color: #fff;
}
.mind-map-box{
  height: 100vh;
  position: relative;
  width: 100%;
}
</style>
